import script from "./MbTheNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./MbTheNav.vue?vue&type=script&setup=true&lang=ts"

import "./MbTheNav.vue?vue&type=style&index=0&id=f765e4e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f765e4e4"]])

export default __exports__